export default __webpack_public_path__ + "static/media/gpay.7642e2bb.png";